import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = {};

// ==============================|| SLICE - AUTH ||============================== //

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      return action.payload;
    },
    logout() {
      return {};
    },
    updatePasswordResetStatus(state, action) {
      state.requirePasswordReset = action.payload;
    },
    updateProviderConnection(state, action) {
      const { provider } = action.payload;
      if (state[provider]) {
        state[provider] = {
          ...state[provider],
          connected: false,
        };
      }
    },
  },
});

export default authSlice.reducer;

export const {
  login,
  logout,
  updatePasswordResetStatus,
  updateProviderConnection,
} = authSlice.actions;

// Legacy action type constants for backward compatibility during migration
export const AUTH_ACTION_TYPES = {
  LOGIN: "auth/login",
  LOGOUT: "auth/logout",
  UPDATE_PASSWORD_RESET_STATUS: "auth/updatePasswordResetStatus",
  UPDATE_PROVIDER_CONNECTION: "auth/updateProviderConnection",
};
